import React from "react";
import { connect } from "react-redux";
import cs from "classnames";

import Button from "~/components/common/Button";
import mapDispatch from "~/misc/mapDispatch";
import { modalChange } from "../../modules/modal/actions";
import backhaulIdentity from '~/modules/backhaul/backhaulIdentity';
import { BOOKNOW, BOOKNOWLOADSMART, BOOKCANCEL, BOOKDELETE } from "~/modules/modal/modes";
import {
  uploadFileAction,
  verifyLoads,
  saveUploadFileAction,
} from "~/modules/bookings/action";

import css from "./index.css";

const type = {
  unbook: {
    color: "Blue",
    text: "Book Now",
  },
  loadmartUnbook: {
    color: "Blue",
    text: "Book Now",
  },
  expired: {
    color: "Grey",
    text: "Expired",
  },
  pending: {
    color: "Orange",
    text: "Waiting for Response",
  },
  accepted: {
    color: "Green",
    text: "Booking Confirmed",
  },
  rejected: {
    color: "Red",
    text: "Booking Rejected",
  },
  canceled: {
    color: "Red",
    text: "Cancelled",
  },
  rc_sent: {
    color: "Green",
    text: "Booking Confirmed",
  },
};

let eventFunc = null;

const uploadloadsmartUrl = (rawUrl) => {
  const matchGroup = rawUrl.match(/\?.*/);
  if(matchGroup) return `/uploadLoadsmart${matchGroup[0]}`;
  return ''
} 

class BookButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
      loadId: this.props.loadId,
      showRC: false,
      rcFiles: [],
      selectedUrl: "",
      showBlackTips: false,
      checkLoading: true,
    };
    this.needVerification = true;
    this.needLoadsmartVerification = true;
    this.pendingLoadsmartVerification = true;
    this.needLoadsmartVerificationAagin = true;
    this.backhaulUrl = ''
    const _this = this;
    eventFunc = (e) => this.toggleRCViewer(e, _this);
  }
  componentWillMount() {
    const { loadIdentity, backhaul} = this.props;
    const identity = backhaulIdentity(loadIdentity);

    const {lists} = backhaul.index[identity.key] || {};
    const [todayBackhaulList,tomorrowBackhaulList] = lists;
    const {url: todayUrl} = todayBackhaulList.pop() || {url : ''};
    const {url: tomorrowUrl} = tomorrowBackhaulList.pop() || {url : 'date=1&'};
    this.backhaulUrl = todayUrl +'&'+ tomorrowUrl.match(/date=(.*?)&/)[0];

    this.updateStatus(this.props);

    this.props
      .verifyLoads({ source: "BOOKING", brokerId: this.props.brokerId })
      .then((res) => {
        if (!res || !Array.isArray(res.data)) return;
        this.needVerification = !!res.data.find((item) => !item.status);
        this.needLoadsmartVerification = ["NEW"].includes(res.onboarding);
        this.pendingLoadsmartVerification = ["PENDING"].includes(res.onboarding);
        this.needLoadsmartVerificationAagin = ["DOCUMENT_REJECTED"].includes(res.onboarding);
        this.onboardingUrl = uploadloadsmartUrl(res.onboardingWebUrl);
        this.setState({
          checkLoading: false,
        })
      });
  }
  componentWillUpdate() {
    // this.updateStatus(props);
  }
  componentWillReceiveProps(nextProps) {
    this.updateStatus(nextProps);
  }
  updateStatus(props) {
    const hasBooked =
      props.bookings.has(this.state.loadId) &&
      props.bookings.get(this.state.loadId);
    let status = hasBooked ? hasBooked["status"] : "unbook";
    let rcFiles = hasBooked ? hasBooked["rcFiles"] : [];
    if (status === "rejected") {
      status = { carrier: "canceled", system: "expired" }[
        hasBooked["rejecter"]
      ];
      status = status ? status : "rejected";
    }
    this.setState({
      status: status,
      rcFiles: rcFiles,
      selectedUrl: rcFiles && rcFiles[0] ? rcFiles[0] : "",
    });
  }
  popupData = () => ({
    popType: "",
    uri: "",
    needVerification: this.needVerification,
    needLoadsmartVerification: this.needLoadsmartVerification,
    needLoadsmartVerificationAagin: this.needLoadsmartVerificationAagin,
    pendingLoadsmartVerification: this.pendingLoadsmartVerification,
    backhaulUrl: this.backhaulUrl,
    onboardingUrl: this.onboardingUrl,
    price: this.props.curRate,
    from: this.props.from,
    to: this.props.to,
    loadId: this.props.loadId,
    bookData: this.props.bookings.get(this.state.loadId),
    updateButton: () => {
      this.updateStatus(this.props);
    },
  });
  popupModal(type) {
    if (type !== "unbook" && type !== "canceled") {
      return;
    }
    const props = this.popupData();
    props.popType = BOOKNOW;
    props.uri = BOOKNOW;
    this.props.showPop(props);
  }
  popupLoadsmartModal(type) {
    //TODO: new booking 
    if (type !== "loadmartUnbook") {
      return;
    }
    const props = this.popupData();
    props.popType = BOOKNOWLOADSMART;
    props.uri = BOOKNOWLOADSMART;
    this.props.showPop(props);
  }
  popupCancelModel(type) {
    if (type !== "pending") {
      return;
    }
    const props = this.popupData();
    props.popType = BOOKCANCEL;
    props.uri = BOOKCANCEL;
    this.props.showPop(props);
  }
  popupDeleteModel(type) {
    if (type !== "canceled" && type !== "expired") {
      return;
    }
    const props = this.popupData();
    props.popType = BOOKDELETE;
    props.uri = BOOKDELETE;
    this.props.showPop(props);
  }
  rcFileChange(type, i) {
    const { rcFiles, selectedUrl } = this.state;
    const maxIndex = rcFiles.length;
    let index = i ? i : rcFiles.indexOf(selectedUrl);
    if (type === "left") {
      index = index < 1 ? maxIndex - 1 : --index;
    } else if (type === "right") {
      index = index > maxIndex - 2 ? 0 : ++index;
    }
    this.rcFileSelect(index);
  }
  rcFileSelect(i) {
    const newUrl = this.state.rcFiles[i];
    if (newUrl !== this.state.selectedUrl) {
      this.setState({ selectedUrl: newUrl });
    }
  }
  toggleRCViewer(e, _this) {
    if (e && 27 !== e.keyCode) return;
    const that = _this || this;
    const { showRC } = that.state;
    if (!showRC) {
      window.addEventListener("keyup", eventFunc);
    } else {
      console.log("s");
      window.removeEventListener("keyup", eventFunc);
    }
    that.setState({ showRC: !showRC });
  }
  uploadDocs(e) {
    const { loadId } = this.state;
    const files = e.target.files || e.dataTransfer.files;
    files[0] &&
      this.props.uploadDocs(files[0]).then((res) => {
        this.props
          .saveUploadDoc({
            loadId: loadId,
            files: [res.url],
          })
          .then(() => {
            this.setState({ showBlackTips: true });
            setTimeout(() => {
              this.setState({ showBlackTips: false });
            }, 2000);
          });
      });
  }
  render() {
    const { status, rcFiles, showRC, showBlackTips } = this.state;
    const { source } = this.props;

    const ViewRC = () => {
      return (
        <section
          className={css.showRC}
          onClick={() => {
            this.toggleRCViewer.call(this);
          }}
        >
          <main
            className={css.showRCContainer}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className={css.showImg}>
              <div
                className={css.showImgLeft}
                onClick={() => {
                  this.rcFileChange.call(this, "left");
                }}
              >
                &lt;
              </div>
              <div className={css.showImgContain}>
                <img src={this.state.selectedUrl} alt="" />
              </div>
              <div
                className={css.showImgRight}
                onClick={() => {
                  this.rcFileChange.call(this, "right");
                }}
              >
                &gt;
              </div>
            </div>
            <div className={css.showList}>
              <div
                className={css.showListLeft}
                onClick={() => {
                  this.rcFileChange.call(this, "left");
                }}
              >
                &lt;
              </div>
              <div className={css.showListContain}>
                {rcFiles.map((url, i) => {
                  return (
                    <div
                      className={cs(css.showListItem, {
                        [css.showListItemSelected]:
                          this.state.selectedUrl === url,
                      })}
                      onClick={() => {
                        this.rcFileSelect.call(this, i);
                      }}
                      key={i}
                    >
                      <img src={url} />
                    </div>
                  );
                })}
              </div>
              <div
                className={css.showListRight}
                onClick={() => {
                  this.rcFileChange.call(this, "right");
                }}
              >
                &gt;
              </div>
            </div>
          </main>
        </section>
      );
    };

    const UploadButton = () => {
      return (
        <label htmlFor={"booking upload"} className={css.uploadBtn}>
          <div className={css.uploadBtnText}>Upload Docs</div>
          <input
            className={css.uploadBtnInput}
            id={"booking upload"}
            type="file"
            accept="image/*"
            multiple
            onChange={(e) => this.uploadDocs.call(this, e)}
          />
        </label>
      );
    };
    if (source === 'loadsmart') {
      let loadsmartStatus = status;
      if(status === "unbook") {
        loadsmartStatus = 'loadmartUnbook'
      } 
      return (
        <div className={cs(css.bookBtns)}>
          <div className={cs(css.btnRows)}>
          <Button
            mods={["wide", "large"]}
            className={cs(
              css.normalize,
              css["color" + type[loadsmartStatus].color || ""],
              loadsmartStatus !== "loadmartUnbook" ? css.normalizeDisable : ""
            )}
            onClick={() => {
              this.popupLoadsmartModal(loadsmartStatus);
            }}
            disabled={(loadsmartStatus !== "loadmartUnbook") || this.state.checkLoading}
          >
            {
              this.state.checkLoading ? "Checking..." : type[loadsmartStatus].text
            }
          </Button>
          </div>
        </div>
      )
    }
    return (
      <div className={cs(css.bookBtns)}>
        <div className={cs(css.btnRows)}>
          <Button
            mods={["wide", "large"]}
            className={cs(
              css.normalize,
              css["color" + type[status].color || ""],
              status !== "unbook" ? css.normalizeDisable : ""
            )}
            onClick={() => {
              this.popupModal(status);
            }}
            disabled={status !== "unbook"}
          >
            {type[status].text || ""}
          </Button>
          {status === "expired" && (
            <Button
              mods={["wide", "large"]}
              className={cs(css.fixed)}
              onClick={() => {
                this.popupDeleteModel(status);
              }}
            >
              Delete
            </Button>
          )}
          {status === "pending" && (
            <Button
              mods={["wide", "large"]}
              className={cs(css.fixed)}
              onClick={() => {
                this.popupCancelModel(status);
              }}
            >
              Cancel
            </Button>
          )}
        </div>
        {status === "canceled" && (
          <div className={cs(css.btnRows)}>
            <Button
              mods={["wide", "large"]}
              className={cs(css.fixedLarge)}
              onClick={() => {
                this.popupModal(status);
              }}
            >
              Rebook
            </Button>
            <Button
              mods={["wide", "large"]}
              className={cs(css.fixedLarge)}
              onClick={() => {
                this.popupDeleteModel(status);
              }}
            >
              Delete
            </Button>
          </div>
        )}
        {(status === "accepted" || status === "rc_sent") && (
          <div className={cs(css.btnRows)}>
            {status === "rc_sent" && (
              <Button
                mods={["wide", "large"]}
                className={cs(css.fixedLarge)}
                onClick={() => {
                  this.toggleRCViewer.call(this);
                }}
              >
                View RC
              </Button>
            )}
            <UploadButton />
          </div>
        )}
        {showRC && <ViewRC />}
        {showBlackTips && <div className={css.backTips}>Upload Succ</div>}
      </div>
    );
  }
}

export default connect(
  ({ user, bookings, loadsSearch, backhaul }, ownProps) => {
    const { bookingMap } = bookings;

    return {
      // shipmentId: loadId,
      // userIsLoggedIn: user.isLoggedIn,
      dot: user.dot,
      email: user.email,
      bookings: bookingMap,
      backhaul,
      ...ownProps,
    };
  },
  mapDispatch({
    verifyLoads: (props, postData) => verifyLoads(postData),
    showPop: (props, popConfig) =>
      modalChange(popConfig.popType, {
        // type: "pop_upgrade_to_new_standard",
        type: "pop",
        ...popConfig,
      }),
    uploadDocs: (props, file) => uploadFileAction(file),
    saveUploadDoc: (props, saveData) => saveUploadFileAction(saveData),
  })
)(BookButton);



// WEBPACK FOOTER //
// ./src/components/BookButton/index.js